import type { SVGProps } from 'react';
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2.5 8h11"
    />
  </svg>
);
export default SvgMinus;
